export const TRAININGS = [
  {
    id: "marketing-de-soi",
    title: "Marketing de soi",
    url: "https://10000codeurs.com/marketing-de-soi/",
    category: "Développement personnel",
    duration: "4 heures",
    level: "Débutant",
    shortDescription: "Apprenez à valoriser vos compétences et à vous démarquer sur le marché du travail.",
    description: "Le marketing de soi est une compétence essentielle pour réussir dans votre carrière professionnelle. À la fin de ce module, vous serez capable de vous vendre efficacement auprès des recruteurs et de vous démarquer des autres candidats.",
    highlights: [
      "Identifier et mettre en valeur vos points forts",
      "Créer un personal branding efficace",
      "Optimiser votre CV et votre profil LinkedIn",
      "Vous présenter de manière percutante en entretien",
      "Développer votre réseau professionnel",
    ],
    objectives: [
      "Identifier vos compétences clés et vos atouts",
      "Construire votre marque personnelle",
      "Maîtriser l'art du pitch",
      "Optimiser votre présence en ligne",
    ],
    icon: "🎯",
    bgColor: "#f97316",
    gradientFrom: "#f97316",
    gradientTo: "#dc2626",
  },
  {
    id: "mentorat",
    title: "Mentorat",
    url: "https://10000codeurs.com/mentorat/",
    category: "Accompagnement",
    duration: "Programme continu",
    level: "Tous niveaux",
    shortDescription: "Bénéficiez d'un accompagnement personnalisé par des professionnels expérimentés.",
    description: "Le programme de mentorat vous met en relation avec des professionnels expérimentés qui vous guideront dans votre parcours. Le mentorat est une opportunité unique d'apprendre de ceux qui ont déjà réussi et d'éviter les erreurs courantes.",
    highlights: [
      "Être accompagné par un mentor du secteur tech",
      "Recevoir des conseils personnalisés pour votre carrière",
      "Développer votre réseau professionnel",
      "Obtenir un retour d'expérience concret du terrain",
      "Accélérer votre insertion professionnelle",
    ],
    objectives: [
      "Trouver un mentor adapté à vos objectifs",
      "Établir une relation de confiance",
      "Définir un plan de développement",
      "Progresser grâce aux retours d'expérience",
    ],
    icon: "🤝",
    bgColor: "#3b82f6",
    gradientFrom: "#3b82f6",
    gradientTo: "#6366f1",
  },
  {
    id: "prise-de-parole-en-public",
    title: "Prise de parole en public",
    url: "https://10000codeurs.com/prise-de-parole-en-public/",
    category: "Communication",
    duration: "6 heures",
    level: "Intermédiaire",
    shortDescription: "Développez votre aisance à l'oral et apprenez à captiver votre audience.",
    description: "La prise de parole en public est une compétence indispensable dans le monde professionnel, que ce soit pour des présentations, des réunions ou des entretiens. Vous gagnerez en confiance et serez capable de vous exprimer avec clarté et conviction.",
    highlights: [
      "Structurer un discours impactant",
      "Gérer le stress et le trac",
      "Utiliser le langage corporel à votre avantage",
      "Captiver et maintenir l'attention de votre audience",
      "Répondre aux questions avec assurance",
    ],
    objectives: [
      "Vaincre le trac et gérer le stress",
      "Structurer vos présentations",
      "Maîtriser votre communication non-verbale",
      "Interagir efficacement avec votre audience",
    ],
    icon: "🎤",
    bgColor: "#a855f7",
    gradientFrom: "#a855f7",
    gradientTo: "#ec4899",
  },
  {
    id: "travail-en-equipe",
    title: "Travail en équipe",
    url: "https://10000codeurs.com/travail-en-equipe/",
    category: "Soft Skills",
    duration: "5 heures",
    level: "Débutant",
    shortDescription: "Maîtrisez les clés d'une collaboration efficace et productive.",
    description: "Le travail en équipe est au cœur de tout projet réussi. Ce module vous donnera les outils pour collaborer efficacement avec vos collègues. Vous apprendrez à être un membre d'équipe efficace et apprécié de vos collaborateurs.",
    highlights: [
      "Les fondamentaux de la collaboration",
      "La communication au sein d'une équipe",
      "La gestion des conflits",
      "Les méthodologies agiles (Scrum, Kanban)",
      "Les outils de collaboration (Git, Slack, Trello)",
    ],
    objectives: [
      "Communiquer efficacement en équipe",
      "Gérer les désaccords de manière constructive",
      "Utiliser les outils de collaboration",
      "Contribuer positivement à la dynamique d'équipe",
    ],
    icon: "👥",
    bgColor: "#22c55e",
    gradientFrom: "#22c55e",
    gradientTo: "#14b8a6",
  },
  {
    id: "anglais",
    title: "Anglais",
    url: "https://10000codeurs.com/anglais/",
    category: "Langues",
    duration: "20 heures",
    level: "Tous niveaux",
    shortDescription: "Renforcez votre anglais professionnel et technique pour le secteur IT.",
    description: "L'anglais est la langue internationale du monde de la tech. Ce module vous aidera à développer vos compétences linguistiques pour évoluer dans un environnement professionnel anglophone. Améliorez votre niveau pour accéder à plus d'opportunités professionnelles.",
    highlights: [
      "Vocabulaire technique IT",
      "Rédaction d'emails professionnels",
      "Participation à des réunions en anglais",
      "Lecture de documentation technique",
      "Préparation aux entretiens en anglais",
    ],
    objectives: [
      "Maîtriser le vocabulaire technique",
      "Communiquer à l'écrit et à l'oral",
      "Comprendre la documentation anglaise",
      "Passer des entretiens en anglais",
    ],
    icon: "🇬🇧",
    bgColor: "#2563eb",
    gradientFrom: "#2563eb",
    gradientTo: "#1e40af",
  },
  {
    id: "preparation-formation",
    title: "Préparation formation",
    url: "https://10000codeurs.com/preparation-formation/",
    category: "Préparation",
    duration: "3 heures",
    level: "Débutant",
    shortDescription: "Préparez-vous efficacement pour tirer le maximum de votre formation.",
    description: "Ce module de préparation vous permet d'arriver prêt et motivé pour votre formation intensive en développement. Une bonne préparation est la clé d'une formation réussie !",
    highlights: [
      "Organiser votre environnement de travail",
      "Installer les outils nécessaires",
      "Adopter les bonnes méthodes d'apprentissage",
      "Gérer votre temps efficacement",
      "Définir vos objectifs personnels",
    ],
    objectives: [
      "Configurer votre environnement de développement",
      "Adopter les bonnes pratiques d'apprentissage",
      "Planifier votre parcours de formation",
      "Vous fixer des objectifs clairs",
    ],
    icon: "📚",
    bgColor: "#eab308",
    gradientFrom: "#eab308",
    gradientTo: "#f97316",
  },
  {
    id: "animation-tutoriels-en-ligne",
    title: "Animation tutoriels en ligne",
    url: "https://10000codeurs.com/animation-tutoriels-en-ligne/",
    category: "Pédagogie",
    duration: "8 heures",
    level: "Intermédiaire",
    shortDescription: "Apprenez à créer et animer des tutoriels en ligne engageants.",
    description: "Partagez vos connaissances en créant des tutoriels en ligne de qualité professionnelle. Devenez un formateur en ligne efficace et inspirant !",
    highlights: [
      "Concevoir des contenus pédagogiques structurés",
      "Utiliser les outils de capture vidéo",
      "Animer des sessions en direct",
      "Engager votre audience",
      "Créer des exercices pratiques",
    ],
    objectives: [
      "Structurer un tutoriel pédagogique",
      "Maîtriser les outils de création vidéo",
      "Animer des sessions interactives",
      "Évaluer l'apprentissage des participants",
    ],
    icon: "🎬",
    bgColor: "#ef4444",
    gradientFrom: "#ef4444",
    gradientTo: "#f43f5e",
  },
  {
    id: "formation-metier-cible",
    title: "Formation métier cible",
    url: "https://10000codeurs.com/formation-metier-cible/",
    category: "Spécialisation",
    duration: "40 heures",
    level: "Avancé",
    shortDescription: "Spécialisez-vous dans le métier tech de votre choix.",
    description: "Ce module vous permet de vous spécialiser dans un métier précis du secteur tech selon vos aspirations et le marché de l'emploi. Faites le bon choix pour votre avenir professionnel !",
    highlights: [
      "Les différents métiers de la tech",
      "Les compétences requises pour chaque métier",
      "Les parcours de carrière possibles",
      "Les tendances du marché de l'emploi",
      "Comment vous positionner stratégiquement",
    ],
    objectives: [
      "Explorer les différents métiers tech",
      "Identifier le métier qui vous correspond",
      "Acquérir les compétences spécifiques",
      "Construire votre plan de carrière",
    ],
    icon: "💼",
    bgColor: "#6366f1",
    gradientFrom: "#6366f1",
    gradientTo: "#9333ea",
  },
  {
    id: "francais",
    title: "Français",
    url: "https://10000codeurs.com/francais/",
    category: "Langues",
    duration: "15 heures",
    level: "Tous niveaux",
    shortDescription: "Perfectionnez votre français professionnel pour exceller en entreprise.",
    description: "Maîtriser le français professionnel est essentiel pour communiquer efficacement en entreprise. Améliorez votre expression pour gagner en crédibilité professionnelle.",
    highlights: [
      "La rédaction professionnelle (emails, rapports)",
      "L'orthographe et la grammaire",
      "Le vocabulaire professionnel",
      "La communication orale formelle",
      "La rédaction de documents techniques",
    ],
    objectives: [
      "Rédiger des emails professionnels impeccables",
      "Maîtriser l'orthographe et la grammaire",
      "S'exprimer clairement à l'oral",
      "Rédiger des documents structurés",
    ],
    icon: "🇫🇷",
    bgColor: "#3b82f6",
    gradientFrom: "#3b82f6",
    gradientTo: "#ef4444",
  },
  {
    id: "preparation-insertion",
    title: "Préparation Insertion",
    url: "https://10000codeurs.com/preparation-insertion/",
    category: "Insertion professionnelle",
    duration: "10 heures",
    level: "Tous niveaux",
    shortDescription: "Préparez votre entrée sur le marché du travail avec succès.",
    description: "Ce module final vous prépare à réussir votre insertion professionnelle dans le secteur tech. Mettez toutes les chances de votre côté pour décrocher votre premier emploi !",
    highlights: [
      "Rédiger un CV percutant",
      "Créer un portfolio attractif",
      "Préparer vos entretiens techniques",
      "Négocier votre salaire",
      "Réussir votre période d'essai",
    ],
    objectives: [
      "Créer un CV et un portfolio efficaces",
      "Réussir vos entretiens techniques",
      "Négocier vos conditions d'embauche",
      "Réussir votre intégration en entreprise",
    ],
    icon: "🚀",
    bgColor: "#10b981",
    gradientFrom: "#10b981",
    gradientTo: "#16a34a",
  },
];
